import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../shared/ui/shadcnTab";
import React from "react";
import Profile from "../components/Profile";
import Preferences from "../components/Preferences";
import Security from "../components/Security";
import ActivityLog from "../components/ActivityLog";


const AccountSettings = () => {
  return (
    <section className="p-4 bg-white md:p-6">
      <h2 className="text-3xl font-[450] tracking-[-2.5%] text-gray-30 mb-3">Account Settings</h2>

      <Tabs defaultValue="Profile">
        <div className="w-full mb-3 border-b border-primary-80">
          <TabsList className="gap-2 p-0 md:gap-4">
            <TabsTrigger value="Profile">Profile</TabsTrigger>
            <TabsTrigger value="Preferences">Preferences</TabsTrigger>
            <TabsTrigger value="Security">Security</TabsTrigger>
            <TabsTrigger value="Activity log">Activity log</TabsTrigger>
          </TabsList>
        </div>
        <TabsContent value="Profile">
          <Profile />
        </TabsContent>
        <TabsContent value="Preferences">
          <Preferences />
        </TabsContent>
        <TabsContent value="Security">
          <Security />
        </TabsContent>
        <TabsContent value="Activity log">
          <ActivityLog />
        </TabsContent>
      </Tabs>
    </section>
  );
};

export default AccountSettings;
